import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './cardContent.less';


class CardContent extends Component {
    render() {

        const className = classNames('card-content', {'no-wrap': this.props.noWrap});
        return <div className={className}>{this.props.children}</div>;
    }
}

CardContent.propTypes = {
    children: PropTypes.node
}

export default CardContent;



// WEBPACK FOOTER //
// ./src/react/card/CardContent.jsx